<template>
  <div class="role-content content-panel">
    <div class="search" style="margin-bottom:20px">
      <a-input-search v-model="searchName" @search="initRoleList()" placeholder="请选择部门" />
    </div>
    <div class="example">
      <a-spin :spinning="loading">
        <a-tree
          v-if="treeList.length > 0"
          :treeData="treeList"
          :draggable="true"
          @select="select"
          :defaultExpandedKeys="defaultExpandedKeys"
          :selectedKeys="selectedKeys"
        >
          <template slot="custom" slot-scope="role">
            <a-tooltip placement="topLeft" :title="role.subcompanyname">
              <span class="title-name">{{ role.subcompanyname }}</span>
            </a-tooltip>
          </template>
        </a-tree>
      </a-spin>
    </div>

  </div>
</template>

<script>
import { getCompanyTree } from '@/api/organizationalStructure'
export default {
  mounted () {
    // 获取树
    this.initRoleList()
  },
  data () {
    return {
      searchName: '',
      loading: false,
      treeList: [],
      selectedKeys: [],
      defaultExpandedKeys: []
    }
  },
  methods: {
    // 获取侧边栏数据
    async initRoleList () {
      this.loading = true
      // 调用接口
      const params = {}
      if (this.searchName) {
        params.subcompanyname = this.searchName.trim()
      }
      const res = await getCompanyTree(params)
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            // do
            // data[i].key = data[i].id
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].children.length) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data)
        if (!this.searchName) {
          this.treeList = [{
            id: '杭氧',
            comid: '杭氧',
            depid: '杭氧',
            key: '杭氧',
            scopedSlots: { title: 'custom' },
            subcompanyname: '杭氧',
            code: '杭氧',
            parent: true,
            children: res.data
          }]
        } else {
          this.treeList = res.data
        }
        this.defaultExpandedKeys = this.treeList.length ? [this.treeList[0].key] : []
        this.selectedKeys = this.treeList.length ? [this.treeList[0].key] : []
      } else {
        this.$message.error(res.info.data)
      }
      this.loading = false
      this.getRoleManage()
    },
    // 获取初始右侧展示数据
    getRoleManage () {
      if (this.treeList.length) {
        this.$store.commit('setTableParams', {
          depid: this.treeList[0].depid,
          comid: this.treeList[0].comid,
          uniqueValue: (new Date()).getTime()
        })
      }
    },
    // 选择一个字典
    select (selectedKeys, info) {
      if (selectedKeys.length === 0) {
        selectedKeys.push(info.node.eventKey)
      }
      this.selectedKeys = selectedKeys
      console.log('节点信息：', info)
      this.$store.commit('setTableParams', {
        depid: info.node.$vnode.data.props.depid,
        comid: info.node.$vnode.data.props.comid
      })
    }
  }
}
</script>

<style lang="less">
.ant-tooltip {
  z-index: 1020;
}
.role-content {
  // .ant-tree-node-content-wrapper {
  //   display: inline-block;
  //   width: calc(100% - 25px);

  //   .ant-tree-title {
  //     display: inline-block;
  //     width: 100%;

  //     .title-name {
  //       // width: inherit;
  //       width:calc(100% - 57px);
  //       display: inline-block;
  //       // white-space: pre-line;
  //       overflow:hidden;
  //       text-overflow:ellipsis;
  //     }
  //   }
  // }
  // .title {
  //   float: left;
  // }

  // .ant-tree {
  //   line-height: 3;

  //   .ant-tree-node-content-wrapper,
  //   .ant-tree-switcher {
  //     margin-top: 7px;
  //   }
  //   .ant-tree-node-content-wrapper:hover {
  //     background: transparent;
  //   }
  //   .ant-tree-treenode-selected {
  //     background: #e6f7ff;
  //     .ant-tree-node-selected {
  //       background: transparent;
  //     }
  //   }

  //   .ant-tree-child-tree {
  //     background: #fff;
  //   }
  //   li {
  //     position: relative;
  //     line-height: 3;
  //     padding-bottom: 0;

  //     ul {
  //       padding: 0px 0 0 10px;
  //     }
  //   }
  // }
  .ant-btn {
    margin-bottom: 12px;
  }

  // .icon-panel {
  //   float: right;
  //   position: absolute;
  //   right: 10px;
  //   top: 13px;

  //   .anticon-plus,
  //   .anticon-edit,
  //   .anticon-delete {
  //     margin-left: 5px;
  //     color: #1890ff;
  //   }
  // }
}
</style>
